/***
 * A custom directive that allows you to restrict the maxlength of an input type="number" field.
 *
 * The length is specified with the number-maxlength property.
 */
const numberMaxlengthDirective = function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, elements, attrs, ngModelCtrl) {
            const element = elements[0];
            const maxLength = attrs.numberMaxlength;
            const maxNumber = parseInt('9'.repeat(maxLength));

            ngModelCtrl.$parsers.push(() => {
                if (element.value > maxNumber) {
                    element.value = parseInt(element.value.toString().slice(0, maxLength))
                }
                return element.value;
            })
        }
    };
};
export default numberMaxlengthDirective;


// WEBPACK FOOTER //
// ./app/common/directives/number-maxlength.directive.js